<template>
  <div class="lightInfo member mgt0">
    <div class="tglWrap" style="border:0px;margin-top:20px">
      <ul v-if="pkgs[selected_pkg].group != 'POWER TRAIN'">
        <li v-for="(prod, i) in pkgProds" :key="i" class="serviceList">
          <i :class="`icon icon${prod.icon}`"></i>
          <div class="tglBtn">
            {{prod.title}}
          </div>
        </li>
      </ul>
      <div v-else>
        <div class="subTitle">
          <i class="icon iconPWrt"></i>
          <div style="margin-left:10px">
            연 <b>1천만원</b> 파워트레인 보증
          </div>
        </div>
        <div class="txt">
          연 1천만원 한도 (부가세 및 부품 & 공임 포함) 까지 부담 없이 보증부품에 대한 교환 가능한 파워트레인 보증 서비스 입니다.
        </div>
        <div class="separator"></div>
        <ul class="cautions">
          <li>※ Standard, Premium 멤버십 구독 시 가입 가능합니다.</li>
          <li>※ 60개월 초과 ~ 96개월 이하/ 18만 Km 이하 주행 거리 차량만 가입 가능합니다.</li>
          <li>※ 영업용 렌터카 및 일부 차량은 가입 불가합니다.</li>
          <li>※ 건당 자기부담금 20만원이 발생합니다.</li>
          <li>※ 면책기간 30일 동안 사용 불가합니다.</li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
  import Const from "../../helpers/Const";

  export default {

    computed:{
      pkgProds() {
        let prods = this.prods[this.selected_pkg];
        prods.sort(function (a,b) {
          if (a.seq > b.seq) return 1;
          if (a.seq < b.seq) return -1;
          return 0;
        });
        return prods;
      }
    },
    data() {
      return {
        pkgs: this.$store.state.pkgs,
        prods: this.$store.state.prods,
        UNIT_TYPE_CURRENCY: Const.PKG_PROD_UNIT_TYPE_CURRENCY,
        UNIT_TYPE_NUMBER: Const.PKG_PROD_UNIT_TYPE_NUMBER,
      };
    },

    methods: {
      changeProdOn(prod_id) {
        const prodList = this.prods[this.selected_pkg];
        prodList.forEach((prod) => {
          if (prod.id == prod_id) prod.on = !prod.on;
          else prod.on = false;
        })
      },
      prodUnitInfo(unit, unit_type) {
        const unitInt = parseInt(unit)
        switch (unit_type) {
          case this.UNIT_TYPE_NUMBER:
            if(unitInt == 999)
              return `제공 횟수 | 무한`;
            else
              return `제공 횟수 | 연 ${unitInt} 회`;
          case this.UNIT_TYPE_CURRENCY:
            return `제공 금액 | 연 ${String(Const.getPriceAddVatRound(unitInt)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원`;
        }
      }
    },

    props: {
      selected_pkg: Number,
    },

    watch: {
      selected_pkg() {
        const prodList = this.prods[this.selected_pkg];
        prodList.forEach((prod) => {
          prod.on = false;
        });
      }
    },
  };
</script>


<style scoped>
</style>